import React from "react";
import theme from '../../theme.module.scss';
import {observer} from "mobx-react";
import {
    AggregateChangeComponent,
    Checkbox,
    Chips,
    FormInput,
    FormSelect,
    Spacer,
    FormTimezonePicker
} from "@vidazoo/ui-kit";
import {normalizeEventValue} from '../../../../../../common/utils/utils';
import {ScheduleReportCreateModel} from '../../../create/model/ScheduleReportCreateModel.mdl';
import {ScheduleReportEditModel} from '../../../edit/model/ScheduleReportEditModel.mdl';
import {ReportVerticalTypes} from '../../../../../../common/enums/ReportVerticalType';
import {ReportDateRange, ReportDelimiters, ReportSchedules} from '../../../../common/scheduleReportEnums';

export interface IDetailsFormProps {
    model: ScheduleReportCreateModel | ScheduleReportEditModel;
}

export default observer(function DetailsForm(props: IDetailsFormProps) {
    const {model} = props;
    const item = model.item.data;

    const onAddRecipient = (value: string, label: string, isNew: boolean, name: string) => {
        model.item.addToParamArray("recipients", value);
    };

    const onRemoveRecipient = (value: string, label: string, name: string) => {
        model.item.removeFromArray(model.item.data.recipients, value);
    };

    const onChangeDetail = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = normalizeEventValue(e);
        if (e.target.name === 'schedule' && value !== 'hourly' && item.dateRange === 'today') model.item.updateParam('dateRange', '');
        model.item.updateParam(e.target.name, value);
    };

    return (
        <div className={theme.form}>
            <AggregateChangeComponent onChange={onChangeDetail}>
                <div className={theme.row}>
                    <FormInput value={item.name} autoFocus className={theme.input} name="name" label="Name" aria-label="Name" required
                               fill/>
                </div>
                <div className={theme.row}>
                    <FormInput value={item.description} className={theme.input} name="description"
                               label="Description" aria-label="Description" fill/>
                </div>
                <div className={theme.row}>
                    <FormSelect items={ReportVerticalTypes} fill maxItems={5}
                                searchable required name="verticalType" label="Vertical Type"
                                value={item.verticalType}
                                className={theme.input} itemValueKey="value" itemLabelKey="label"/>
                </div>
                <div className={theme.row}>
                    <FormSelect value={item.schedule} name="schedule" className={theme.input} fill label="Schedule"
                                itemLabelKey="label" itemValueKey="value" required items={ReportSchedules}
                                maxItems={5}/>
                </div>
                <div className={theme.row}>
                    <div className={theme.recipients}>
                        <Chips name="recipients" searchPlaceholder="Add Recipient Email" allowCreate fill
                               allowOrder={false} onSelect={onAddRecipient} onDelete={onRemoveRecipient}
                               chips={item.recipients}/>
                    </div>
                </div>
                <div className={theme.row}>
                    <FormSelect value={item.dateRange} name="dateRange" className={theme.input} fill
                                label="Date Range" itemLabelKey="label" itemValueKey="value" required
                                items={item.schedule === 'hourly' ? [{value: 'today', label: 'Today'}, ...ReportDateRange] : ReportDateRange} maxItems={5}/>
                    <FormTimezonePicker timezone={item.timezone} name="timezone" label="Timezone" searchable
                                    required className={theme.input}/>
                    <FormSelect value={item.delimiter} name="delimiter" className={theme.input} fill
                                label="Delimiter" itemLabelKey="label" itemValueKey="value" required
                                items={ReportDelimiters}/>
                </div>
                <div className={theme.row}>
                    <Spacer right={48}>
                        <Checkbox checked={item.isActive} name="isActive" label="Active" onChange={onChangeDetail}/>
                    </Spacer>
                    <Spacer right={48}>
                        <Checkbox checked={item.sendEmpty} name="sendEmpty"
                                  label="Send report even if empty" onChange={onChangeDetail}/>
                    </Spacer>
                </div>
            </AggregateChangeComponent>
        </div>
    );
});
